import { Link } from 'gatsby';
import React from 'react';
import renderLink from '~/utils/render-link';

function IconLink({ children, className, to = '#', color = 'black', type = 'link' }) {
  const externalOrMailTo = /^(mailto|#)|https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/.test(to);

  const innerContent = (
    <>
      <div className="icon-link__label">
        <span>{children}</span>
        <span aria-hidden="true">{children}</span>
      </div>
      <div className="icon-link__underline"></div>
    </>
  );

  return (
    <div className={`icon-link ${className} icon-link--${color}`}>
      {externalOrMailTo ? (
        <a href={to} target="_blank" rel="noopener noreferrer" className="icon-link__link">
          {innerContent}
        </a>
      ) : (
        <>
          {type === 'link' ? (
            <Link to={renderLink(to)} className="icon-link__link">{innerContent}</Link>
          ) : (
            <button to={renderLink(to)} className="icon-link__link">{innerContent}</button>
          )}
        </>
      )}
    </div>
  );
}

export default IconLink;
